import { Descriptions, Image, Space, Tag } from 'antd';
import React from 'react';

export const fileUrl = (f) => {
  if (!f) return null;
  if (typeof f === 'string') return f;
  return f.file_name || f.url || f.path || null;
};

export const fileList = (...groups) => {
  const out = [];
  groups.forEach((g) => {
    const arr = !g ? [] : Array.isArray(g) ? g : [g];
    arr.forEach((f) => {
      const u = fileUrl(f);
      if (u) out.push(u);
    });
  });
  return out;
};

export const fmtDate = (v) => {
  if (!v) return '—';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? String(v) : d.toLocaleString();
};

export const fmtDay = (v) => {
  if (!v) return '—';
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? String(v).slice(0, 10) : d.toLocaleDateString();
};

export const categoryLabel = (c) =>
  c?.name || c?.category_name || (typeof c === 'string' ? c : null) || '—';

export const FileGallery = ({ title, files, empty = 'None uploaded' }) => (
  <div style={{ marginBottom: 16 }}>
    <strong>{title}</strong>
    <div style={{ marginTop: 8 }}>
      {!files?.length ? (
        <span style={{ color: '#8c8c8c' }}>{empty}</span>
      ) : (
        <Image.PreviewGroup>
          <Space wrap>
            {files.map((src) => (
              <Image
                key={src}
                src={src}
                width={96}
                height={96}
                style={{ objectFit: 'cover', borderRadius: 8 }}
              />
            ))}
          </Space>
        </Image.PreviewGroup>
      )}
    </div>
  </div>
);

export const OutletDetailBody = ({ outlet, extra }) => {
  if (!outlet) return null;
  const user = outlet.user || {};
  const photos = fileList(outlet.photo_library, outlet.outlet_images);
  const docs = fileList(outlet.document_image);
  return (
    <>
      <Descriptions bordered size="small" column={2} style={{ marginBottom: 16 }}>
        <Descriptions.Item label="Outlet" span={2}>
          {outlet.name || '—'}{' '}
          {outlet.is_verified ? (
            <Tag color="green">Verified</Tag>
          ) : (
            <Tag color="orange">Pending</Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Owner">{user.full_name || '—'}</Descriptions.Item>
        <Descriptions.Item label="Owner mobile">
          {user.mobile_number || '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Email">{user.email || '—'}</Descriptions.Item>
        <Descriptions.Item label="Shop mobile">
          {outlet.mobile_number || '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Category" span={2}>
          {categoryLabel(outlet.category)}
        </Descriptions.Item>
        <Descriptions.Item label="Address" span={2}>
          {[outlet.address, outlet.city, outlet.state, outlet.pin_code]
            .filter(Boolean)
            .join(', ') || '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Hours">
          {outlet.opening_time || '—'} – {outlet.closing_time || '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Weekly off">
          {outlet.weekoff?.trim?.() || outlet.weekoff || 'Not provided'}
        </Descriptions.Item>
        <Descriptions.Item label="License no.">
          {outlet.licenseNumber || 'Not provided'}
        </Descriptions.Item>
        <Descriptions.Item label="Valid till">
          {outlet.licenseValidTo ? fmtDay(outlet.licenseValidTo) : 'Not provided'}
        </Descriptions.Item>
        <Descriptions.Item label="Min. bill">
          {outlet.minimum_buy ?? '—'}
        </Descriptions.Item>
        <Descriptions.Item label="Active">
          {outlet.is_active === false ? 'No' : 'Yes'}
        </Descriptions.Item>
        <Descriptions.Item label="Created">{fmtDate(outlet.createdAt)}</Descriptions.Item>
        <Descriptions.Item label="Updated">{fmtDate(outlet.updatedAt)}</Descriptions.Item>
        {outlet.location?.coordinates?.length === 2 && (
          <Descriptions.Item label="Map pin" span={2}>
            {outlet.location.coordinates[1]}, {outlet.location.coordinates[0]}
          </Descriptions.Item>
        )}
        {extra}
      </Descriptions>
      <FileGallery title="Shop photos" files={photos} />
      <FileGallery title="GST / license documents" files={docs} />
    </>
  );
};
